<div class="w-full h-full bg-pattern" fxLayout="row">
  <div class="left">
    <!-- <div @fadeInUp class="overflow-hidden w-full max-w-md"> -->
    <div class="auth-logo-card" fxLayout="column" fxLayoutGap="10px">
      <img src="assets/puma-logo.png" alt="PUMA Logo" class="logo" />
    </div>
    <!-- </div> -->
  </div>
  <div class="right">
    <div class="text-center">
      <h2 class="title m-0" style="color: var(--app-heading)">Welcome back!</h2>
      <h4 class="body-2 text-secondary m-0">Sign in to continue.</h4>
    </div>

    <div class="overflow-hidden w-full max-w-md">
      <div class="p-4" fxLayout="column" fxLayoutGap="10px">
        <form (submit)="onLogin(loginForm)" #loginForm="ngForm" class="mb-2">
          <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input
              matInput
              name="email"
              ngModel
              type="email"
              placeholder="E-Mail"
              #email="ngModel"
              required
              email
              autocomplete="off"
            />
            <mat-error *ngIf="email.invalid"
              >Please enter a valid email.</mat-error
            >
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Password</mat-label>
            <input
              matInput
              [type]="showPassword ? 'text' : 'password'"
              type="password"
              name="password"
              ngModel
              placeholder="Password"
              #password="ngModel"
              required
              autocomplete="off"
            />
            <mat-error *ngIf="password.invalid"
              >Please enter a valid password.</mat-error
            >
            <mat-icon matSuffix (click)="togglePasswordVisibility()">
              {{ showPassword ? "visibility" : "visibility_off" }}
            </mat-icon>
          </mat-form-field>
          <div class="remember-me-container">
            <mat-checkbox [(ngModel)]="rememberMe" name="rememberMe">Keep me signed in</mat-checkbox>
          </div>

          <button
            mat-raised-button
            matTooltip="Sign in"
            class="primary-button"
            type="submit"
            [class.spinner]="isLoading"
            [disabled]="isLoading"
          >
            Sign in
          </button>
          <div fxLayout="column" fxLayoutAlign="center" class="forgot-password-container">
            <div class="text-center">
                <button
                  mat-button
                  class="forgot-password-button"
                  type="button"
                  (click)="btnClick()"
                >
                  Forgot password
                </button>
            </div>
          </div>
          
        </form>
      </div>
    </div>
  </div>
</div>
